import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { FormGroup, Button, Input } from "reactstrap";
import search from "../assets/search_white.png";
import user from "../assets/user.png";
import MyStorage from "./util/storage";
import Api from "./api/api";
import MyLoader from "./util/loader";
import { ToastContainer } from "react-toastify";

const ProReferrals = () => {
  const history = useHistory();
  const [models, setModels] = useState([]);
  const [pageNo, setPageNo] = useState(1); // pagination disabled
  const [keyword, setKeyword] = useState("");
  const [showMore, setShowMore] = useState(true);
  const [loader, setLoader] = useState(false);

  // load data
  useEffect(() => {
    loadData();
  }, [pageNo]);

  const loadData = () => {
    setTimeout(() => {
      setLoader(true);
      console.log("history",);
      Api.getMyReferrals(
        history.location.state.user.id,
        pageNo,
        (response) => {
          setLoader(false);
          if (response.status === "success") {
            if (response.data.length > 0) {
              setModels(response.data);
            }
          }
        },
        (error) => {
          setLoader(false);
        }
      );
    }, 50);
  };

  const searchUsers = (keyword) => {
    if (keyword === "") {
      setModels([]);
      setPageNo(1); // reload
      return;
    }
    setShowMore(false);
    Api.searchUsers(
      keyword,
      (response) => {
        if (response.status === "success") {
          if (response.data.length > 0) {
            setModels(response.data);
          }
        }
      },
      (error) => {
        //
      }
    );
  };

  const getProfilePhoto = (model) => {
    if (
      MyStorage.getFileUrls() == null ||
      model.photo == null ||
      model.photo === ""
    ) {
      return user;
    } else {
      if (model.photo.includes("http")) {
        return model.photo;
      }
      return MyStorage.getFileUrls().User + model.photo;
    }
  };

  return (
    <div className="main">
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FormGroup style={{ width: 400 }}>
          <Input
            type="email"
            placeholder="Search user by email or name..."
            value={keyword}
            onChange={(event) => {
              setKeyword(event.target.value);
            }}
          />
        </FormGroup>
        <div
          style={{
            backgroundColor: "black",
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 20,
            marginLeft: 10,
          }}
        >
          <img
            onClick={() => {
              console.log("click");
              searchUsers(keyword);
            }}
            src={search}
            style={{ width: 30, height: 30 }}
            className="icon-btn"
          />
        </div>
      </div> */}
      <div style={{ marginTop: 10 }}></div>
      {models.map((model, index) => {
        console.log("model", model);
        if (model.type === "admin") {
          return null;
        }
        let className =
          index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className={className} style={{ marginTop: 0 }}>
              <div className="projects-item-photo">
                <img
                  src={getProfilePhoto(model)}
                  style={{ padding: 1, width: 70, height: 70 }}
                />
              </div>
              <div className="projects-item-cat" style={{}}>
                <div style={{ fontSize: 16, color: "blue" }}>#{model.id}</div>
                <div style={{ fontSize: 16 }}>
                  {model.fname} {model.lname}
                </div>
                <div style={{ fontSize: 16 }}>{model.email}</div>
                {/* <div style={{ color: 'green' }}>{model.subscriber === '1' ? 'Member' : 'Non-Member'}</div> */}
                {model.status === "suspended" ? (
                  <div style={{ color: "red" }}>Suspended</div>
                ) : null}
              </div>

              <div
                className="projects-item-cat"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {console.log("model.is_referral_active", model.is_referral_active)}
                <Button
                  className="btn-block btn-submit"
                  style={{ width: 150, fontSize: 16, marginRight: 5, color: 'white', backgroundColor: model.is_referral_active == 1 ? 'red' : "green" }}
                  onClick={() => {
                    if (model.is_referral_active == 1) {
                      if (window.confirm('Are you sure you wish to disable this referral?')) {
                        setLoader(true);
                        Api.disableReferral(
                          history.location.state.user.id,
                          model.id,
                          (response) => {
                            setLoader(false);
                            if (response.status === "success") {
                              setModels(models.map(m => {
                                if (m.id == model.id)
                                  m.is_referral_active = 0;
                                return m
                              }))
                            }
                          },
                          (error) => {
                            setLoader(false);
                          }
                        );
                      }
                    } else {
                      if (window.confirm('Are you sure you wish to enable this referral?')) {
                        setLoader(true);
                        Api.enableReferral(
                          history.location.state.user.id,
                          model.id,
                          (response) => {
                            setLoader(false);
                            if (response.status === "success") {
                              setModels(models.map(m => {
                                if (m.id == model.id)
                                  m.is_referral_active = 1;
                                return m
                              }))
                            }
                          },
                          (error) => {
                            setLoader(false);
                          }
                        );
                      }
                    }
                  }}
                >
                  {model.is_referral_active ? "Remove" : "Add"}
                </Button>
                <Button
                  className="btn-block btn-submit"
                  style={{ width: 150, fontSize: 16 }}
                  onClick={() => {
                    console.log("click");
                    history.push({
                      pathname: "/user-details",
                      state: { user: model },
                    });
                  }}
                >
                  View Details
                </Button>
              </div>
            </div>

            {/* {index == models.length - 1 ?
              showMore ?
                <Button
                  className='btn-block btn-submit'
                  style={{ width: 150, marginTop: 15 }}
                  onClick={() => {
                    console.log('click');
                    setPageNo(pageNo + 1)
                    // loadData()
                  }}>
                  Load More
                </Button>
                :
                null
              :
              null
            } */}
          </div>
        );
      })}
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default ProReferrals;
